import { render } from "./PropertySettings.vue?vue&type=template&id=368481aa&ts=true"
import script from "./PropertySettings.vue?vue&type=script&lang=ts"
export * from "./PropertySettings.vue?vue&type=script&lang=ts"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__